import script from "./PrintDom.vue?vue&type=script&setup=true&lang=js"
export * from "./PrintDom.vue?vue&type=script&setup=true&lang=js"

import "./PrintDom.vue?vue&type=style&index=0&id=f512686e&lang=less"

const __exports__ = script;

export default __exports__